import PropTypes from 'prop-types';
import React from 'react';
import { isNil, isObject, has } from 'lodash';
import S from './eventTable.scss';
import { titleize } from '../../../../utils';
import { getMinLocalDate, getSimpleLocalDate, isValidDate } from '../../../../utils/dateUtils';
import eventShape from 'types/event';

const formatValue = (value) => {
  if (isValidDate(value)) return getSimpleLocalDate(value);
  return value.toString();
};

const parseValue = (value, keys) => {
  if (isNil(value)) return '';
  if (!isObject(value) || keys.length === 1) return formatValue(value);
  if (!has(value, keys[1])) return '';
  return parseValue(value[keys[1]], keys.slice(1));
};

const getValue = (data, key) => {
  const keys = key.split('.');
  return parseValue(data[keys[0]], keys);
};

const EventTable = ({ events, dataKeys }) =>
  <table className={S.table}>
    <thead>
      <tr>
        <th className={S.header}>User</th>
        <th className={S.header}>Updated</th>
        {dataKeys.map(key => <th className={S.header} key={key}>{titleize(key)}</th>)}
      </tr>
    </thead>
    <tbody>
      {events.map(event =>
        <tr key={event.id}>
          <td className={S.data}>{event.user}</td>
          <td className={S.data}>{getMinLocalDate(event.created_at)}</td>
          {dataKeys.map(key =>
            <td className={S.data} key={key}>{getValue(event.data, key)}</td>)}
        </tr>,
      )}
    </tbody>
  </table>;

EventTable.defaultProps = { dataKeys: [], events: [] };

EventTable.propTypes = {
  dataKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  events: PropTypes.arrayOf(eventShape).isRequired,
  levelerEvents: PropTypes.bool.isRequired,
};

export default EventTable;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/components/eventTable.jsx